/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["strong.terms[_ngcontent-%COMP%]{font-size:14px}\n/*# sourceMappingURL=forgot-password.component.css.map*/"];
export { styles as styles };
